import gql from 'graphql-tag';

export const query = gql`
    query articlePage(
        $sitename: String
        $parentId: String
        $slug: String
        $preview: Boolean
    ) {
        articles: articleCollection(
            where: {site: $sitename, parentId: $parentId, slug: $slug}
            preview: $preview
            limit: 1
        ) {
            items {
                slug
                site
                headline
                heroFile {
                    url
                }
                heroVideo
                metaTitle
                metaDescription
                datePublishedCustom
                sys {
                    firstPublishedAt
                    publishedAt
                }
                richTextContent {
                    json
                    links {
                        assets {
                            hyperlink {
                                sys {
                                    id
                                }
                                url
                            }
                        }
                        entries {
                            block {
                                sys {
                                    id
                                }
                                ... on MediaBlock {
                                    caption
                                    alignMedia
                                    link
                                    mediaFile {
                                        url
                                        description
                                    }
                                }
                                ... on ExternalLinkCarousel {
                                    title
                                    externalLinksCollection {
                                        items {
                                            title
                                            details
                                            link
                                            image {
                                                url
                                            }
                                        }
                                    }
                                }
                                ... on ArticleEmbed {
                                    embeddedContent
                                }
                                ... on NewsletterSignup {
                                    heading
                                    subheading
                                    buttonLabel
                                }
                            }
                            hyperlink {
                                sys {
                                    id
                                }
                                ... on Article {
                                    path
                                }
                                ... on Category {
                                    path
                                }
                            }
                            inline {
                                sys {
                                    id
                                }
                                ... on ArticleLink {
                                    text
                                    uri
                                    relationship
                                }
                            }
                        }
                    }
                }
                hreflangData: hreflang
            }
        }
    }
`;
